import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  GetAllVendorServiceCategories,
  GetVendorByIdAPI,
} from '../../../../Services';
import { useTranslation } from 'react-i18next';
import { VendorsTranslationPath } from '../I18n/VendorsLocale';
import { GetParams, showError } from '../../../../Helper';

const VendorContext = createContext({
  vendorDetails: {},
  categories: [],
  vendorId: null,
  refetchCategories: () => {},
});
export const useVendorContext = () => useContext(VendorContext);
const VendorContextProvider = ({ children }) => {
  const { t } = useTranslation(VendorsTranslationPath);
  const [vendor, setVendor] = useState({});
  const [categories, setCategories] = useState([]);
  const vendorId = +GetParams('id');
  const getVendor = async () => {
    try {
      const data = await GetVendorByIdAPI(vendorId);
      setVendor(data);
    } catch (error) {
      showError(t('something_went_wrong'));
    }
  };

  const getAllVendorServiceCategories = async () => {
    try {
      const { result } = await GetAllVendorServiceCategories({
        pageIndex: 1,
        pageSize: 100,
        vendorId,
      });
      setCategories(result);
    } catch (error) {
      showError(t('something_went_wrong'));
    }
  };
  useEffect(() => {
    getVendor();
    getAllVendorServiceCategories();
  }, []);
  return (
    <VendorContext.Provider
      value={{
        vendorDetails: vendor,
        categories,
        vendorId,
        refetchCategories: getAllVendorServiceCategories,
      }}
    >
      {children}
    </VendorContext.Provider>
  );
};
export default VendorContextProvider;
